<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteAdmin" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="adminsHandler"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :page.sync="page"
      @page-count="pageCount = $event"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Admins</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            to="/admin/add"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark> mdi-plus-circle-outline </v-icon>
            New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.plain_password }}</td>
          <td>{{ item.role_name }}</td>
          <td>
            <div>
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-1 white--text"
                depressed
              >
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  props: {
    admins: {
      type: Array,
    },
  },
  components: {
    ConfirmBox,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 5,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Password", value: "plain_password" },
      { text: "Role", value: "role_name" },
      { text: "Actions", value: "actions", align: "start" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Admin", ["roles"]),
    adminsHandler() {
      const admins = this.admins.map((data) => {
        const item = this.roles.find((role) => {
          return data.role == role.id;
        });
        data.role_name = item.name;
        return data;
      });
      return admins;
    },
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteAdmin() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Admin/deleteAdmin", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push({
        name: "edit-admin",
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
